import { landingMarket } from "../../roofingLight/landingMarket";
import { testDriveAddressForCountry } from "../../roofingLight/testDrive/testDriveAddress";
import { TEST_DRIVE_BOT, TEST_DRIVE_SERVICE } from "../../roofingLight/testDrive/testDriveLead";

const TRACKING_KEYS = [
  "gclid",
  "fbclid",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gbraid",
  "wbraid",
];

function trimmedText(value) {
  return typeof value === "string" ? value.trim() : "";
}

function trackingFrom(search) {
  const params = typeof search === "string" ? new URLSearchParams(search) : search;
  const read = params?.get;
  const fields = {};
  TRACKING_KEYS.forEach((key) => {
    if (typeof read !== "function") {
      fields[key] = "";
      return;
    }
    const value = read.call(params, key);
    fields[key] = value == null || value === "" ? "" : value;
  });
  return fields;
}

export function buildDemoCallLead({
  name,
  phone,
  email,
  website,
  preferTimeSlot,
  country,
  pageUrl,
  search,
}) {
  const nextName = trimmedText(name);
  const nextPhone = trimmedText(phone);
  const nextEmail = trimmedText(email);
  const pageText = typeof pageUrl === "string" ? pageUrl.trim() : "";
  const slot = trimmedText(preferTimeSlot);
  if (!nextName || !nextPhone || !nextEmail || !pageText || !slot) return null;
  if (typeof country !== "string" || !/^[A-Z]{2}$/.test(country)) return null;

  return {
    name: nextName,
    phone: nextPhone,
    email: nextEmail,
    website: trimmedText(website),
    prefer_time_slot: slot,
    country,
    tested_bot: TEST_DRIVE_BOT,
    address: testDriveAddressForCountry(country, landingMarket(country)),
    service_required: TEST_DRIVE_SERVICE,
    current_url_page: pageText,
    ...trackingFrom(search),
  };
}
